import React from 'react';
import { Image, Button, ImageSizeEnum, Heading, HeadingEnum, BoldEnum } from '@desquared/wave-components-library';
import cn from 'classnames';
import styles from './EmptyState.module.css';
import EmptyStateImg from '../../../public/assets/wave-grocery/Empty State.png';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

export default function EmptyState() {
  const router = useRouter();
  const t = useTranslations('common');

  return (
    <div className={cn(styles.state)}>
      <Image size={ImageSizeEnum.ProductRef} imgSrc={EmptyStateImg.src} imgTitle={'empty-state'} alt={'Empty State'} />
      <Heading type={HeadingEnum.HeadingM} bold={BoldEnum.Bold}>
        {t('empty_state_title')}
      </Heading>
      <Button
        onClick={() => {
          router.push('/');
        }}
        text={t('thank_you.button_text')}
        variant="filled"
      />
    </div>
  );
}
